import { render, staticRenderFns } from "./ValidarRecibo.vue?vue&type=template&id=7005eb32"
import script from "./ValidarRecibo.vue?vue&type=script&lang=js"
export * from "./ValidarRecibo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports